import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/auth.guard';

import { CustomerDashboardComponent } from './customer-dashboard/customer-dashboard.component';

import { CustomerComponent } from './customer.component';
import { DealerAccountComponent } from '../dealer/dealer-account/dealer-account.component';
import { DealerAppointmentsComponent } from '../dealer/dealer-appointments/dealer-appointments.component';
import { DealerConversationsComponent } from '../dealer/dealer-conversations/dealer-conversations.component';
import { CustomerBuyComponent } from '../customer/customer-buy/customer-buy.component';
import { CustomerRentComponent } from '../customer/customer-rent/customer-rent.component';
import { DealerNotificationsComponent } from '../dealer/dealer-notifications/dealer-notifications.component';

import { DealerAlertsComponent } from '../dealer/dealer-alerts/dealer-alerts.component';
import { CustomerBuyFavoritesComponent } from './customer-buy-favorites/customer-buy-favorites.component';
import { CustomerRentFavoritesComponent } from './customer-rent-favorites/customer-rent-favorites.component';
import { DealerBecomePartnerComponent } from '../dealer/dealer-become-partner/dealer-become-partner.component';
import { PostNewCarComponent } from '../owner/post-new-car/post-new-car.component';
import { ProviderParkComponent } from '../provider/provider-park/provider-park.component';
import { CustomerKeepComponent } from './customer-keep/customer-keep.component';
import { CustomerKeepFavoritesComponent } from './customer-keep-favorites/customer-keep-favorites.component';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';


const routes: Routes = [
  {
    path: '', component: CustomerComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: DealerAccountComponent },

      { path: 'dashboard', canActivate: [AuthGuard], component: CustomerDashboardComponent },

      { path: 'park', canActivate: [AuthGuard], component: ProviderParkComponent },
      { path: 'post-new-car', component: PostNewCarComponent },

      //{ path: 'buy-favorites', canActivate: [AuthGuard], component: CustomerBuyFavoritesComponent  },
      { path: 'buy-favorites', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.FAVORITE ] }},
      { path: 'buy-ongoing', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }},
      { path: 'buy-completed', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }},
      
      { path: 'buy-alerts', canActivate: [AuthGuard], component: DealerAlertsComponent, data: { businessLine: CarBusinessLine.BUY }  },
      

      { path: 'rent-favorites', canActivate: [AuthGuard], component: CustomerRentFavoritesComponent  },
      
      { path: 'rent-bookings', canActivate: [AuthGuard], component: CustomerRentComponent, data: { transactionStages: [ TransactionStage.PENDING ] }},     
      { path: 'rent-ongoing', canActivate: [AuthGuard], component: CustomerRentComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }},
      { path: 'rent-completed', canActivate: [AuthGuard], component: CustomerRentComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }},
      
      { path: 'rent-alerts', canActivate: [AuthGuard], component: DealerAlertsComponent, data: { businessLine: CarBusinessLine.RENT }  },
      

      { path: 'servicing-favorites', canActivate: [AuthGuard], component: CustomerKeepFavoritesComponent  },
      { path: 'servicing-plan', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }   },
      
      { path: 'servicing-ongoing', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }  },
      { path: 'servicing-completed', canActivate: [AuthGuard], component: CustomerKeepComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }  },
      
      { path: 'servicing-alerts', canActivate: [AuthGuard], component: DealerAlertsComponent, data: { businessLine: CarBusinessLine.KEEP }  },
      

      { path: 'notifications', canActivate: [AuthGuard], component: DealerNotificationsComponent  },
      { path: 'appointments', canActivate: [AuthGuard], component: DealerAppointmentsComponent  },
      { path: 'conversations', canActivate: [AuthGuard], component: DealerConversationsComponent },


      { path: 'account', canActivate: [AuthGuard], component: DealerAccountComponent },
      { path: 'account-settings', canActivate: [AuthGuard], component: DealerAccountComponent },
      { path: 'become-partner', canActivate: [AuthGuard], component: DealerBecomePartnerComponent },
      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule { }

